//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    tabIndex: { // 爆仓数据详情里面用到
      type: Number, default: 0
    },
    isRight: { // 下拉框是否右对齐
      type: Boolean, default: true
    },
    leftText: { // 左边的文本
      type: String, default: 'EA商城'
    },
    showText: { // 左边的文本是否展示
      type: Boolean, default: true
    },
    type: { // 爆仓数据详情里面用到
      type: Number, default: 1
    },
    tabsData: { // tab数据
      type: Array, default: () => []
    },
    isTranslate: { // 是否需要翻译
      type: Boolean, default: true
    },
    newIcon: {
      type: Boolean, default: false
    }
  },
  data () {
    return {
      downShow: false, // 下拉框显示隐藏
      tabsIndex: 0, // 当前选中的tab
      text: '' // 当前选中的tab name
    }
  },
  watch: {
    tabIndex () {
      this.text = this.tabsData[0].name
      this.tabsIndex = 0
    }
  },
  created () {
    this.text = this.tabsData[0]?.name
  },
  mounted () {
    document.addEventListener('click', this.closeDrop)
    this.tabsIndex = this.tabIndex
    this.text = this.tabsData[this.tabIndex]?.name
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeDrop)
  },
  methods: {
    // 点击非组件区域关闭下拉框
    closeDrop (e = {}) {
      if (!this.$refs?.rightDom?.contains(e?.target)) this.downShow = false
    },
    handleClick (name = '', index = 0) {
      this.$emit('mobileTab', { name, index, type: this.type })
      this.tabsIndex = index
      this.text = name
      this.downShow = false
    }
  }
}
